import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
import { Account, AccountDto } from '../../types/AccountDefault.types';
import { logout } from './authSlice';

type AccountState = {
  account: Account | null;
  accountLoading: boolean;
  accountError: string | null;
};

const initialState: AccountState = {
  account: null,
  accountLoading: false,
  accountError: null
};

export const accountDefaultSlice = createSlice({
  name: 'accountDefault',
  initialState,
  reducers: {
    fetchAccountStart: (state) => {
      state.account = null;
      state.accountLoading = true;
      state.accountError = null;
    },
    fetchAccountSuccess: (state, action: PayloadAction<AccountDto>) => {
      state.account = action.payload.account;
      state.accountLoading = false;
    },
    fetchAccountFailure: (state, action) => {
      state.accountLoading = false;
      state.accountError = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, () => initialState)
      .addCase(PURGE, () => initialState);
  }
});

export const { fetchAccountStart, fetchAccountSuccess, fetchAccountFailure } =
  accountDefaultSlice.actions;

export default accountDefaultSlice.reducer;
